import { CompanyAddress } from './companyAddress';
import { TenantGeneralData } from './tenantGeneralData';
import { Customer } from './customer';
import { Supplier } from './supplier';
import { CompanyContact } from './companyContact';
import { Farm } from './farm';
import { SupplyChainDestination } from './supplyChainDestination';

export class Company extends TenantGeneralData {
  type: string = null;
  subType: string = null;
  name: string = null;
  note: string = null;
  vat: string = null;
  fiscalCode: string = null;
  legalName: string = null;
  techName: string = null;
  recipientCode: string = null;
  qualification: string = null; //in supplier and customer
  imgUrl?: string = null;

  suppliers: Array<Supplier> = [];
  customers: Array<Customer> = [];
  addresses: Array<CompanyAddress> = [];
  contacts: Array<CompanyContact> = [];
  supplyChainDestination?: SupplyChainDestination;
  isAutomatic?: boolean = false;
  nationalFarmRegistryNumber?: string = null; // Required attribute for the Spanish CAP related to developments linked to the CUE.
  autonomousFarmRegistryNumber?: string = null; // Required attribute for the Spanish CAP related to developments linked to the CUE.
  foodRegistrationCode?: string = null; // Required attribute for the Spanish CAP related to developments linked to the CUE.

  farm: Farm;
}
